import PropTypes from 'prop-types';

import latlng from './latlng';

export default PropTypes.shape({
  center: latlng,
  zoom: PropTypes.number
});


//////////////////
// WEBPACK FOOTER
// ../~/react-leaflet/es/propTypes/viewport.js
// module id = 506
// module chunks = 0